<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em">

    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: _get(meta, 'navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <east-search-programs
      :showBottom="true"
      :list="ProgramsList"
      @pageChange="doPageChange"
      @itemClick="onItemClick"
      @search="doSearch"
      @filterByOrigin="doFilterByOrigin">
      <template slot="top-title-center">{{ $t(_get(meta, 'title', 'label.search_programs')) }}</template>

      <div
        slot="bottom"
        class="bottom__row"
        style="padding: 0.5em 0"
        v-if="_get(meta, 'navigation.itemNew')">
        <router-link
           class="el-button el-button el-button--small el-button--nuttrema-orange"
          :to="{ name: _get(meta, 'navigation.itemNew.name') }">
          <i class="far fa-plus" aria-hidden="true"></i> {{ $t(_get(meta, 'navigation.itemNew.label')) }}
        </router-link>
      </div>
    </east-search-programs>

    <router-view></router-view>

  </nuttrema-layout-west-slide>
</template>

<script>
import { get } from 'lodash';

import { PROGRAMS_KEYS } from 'constants/types';

import EastSearchFilter from 'components/ui/search/east-search-filter';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import PageProps from 'components/mixins/page-props';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import ServerSidePageList from 'components/mixins/server-side-page-list';

import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';

import EastSearchPrograms from './cmpt-east-search-programs';

export default {
  name: 'page-search-programs',
  mixins: [
    PageProps,
    ServerSidePageList,
  ],
  components: {
    EastSearchPrograms,
    EastSearchFilter,
    NuttremaIconicaKcal,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      type: PROGRAMS_KEYS.program, // show all programs
      paramsDefault: {
        per_page: 100,
        context: 'assign',
        include: 'image,allergens',
        group_by: 'type_category',
      },
    };
  },
  computed: {
    ProgramsList() {
      return this.$store.getters.ProgramsList(this.type);
    },
    monitored() {
      return this.ProgramsList;
    },
    totalPages() {
      return get(this.ProgramsList, 'meta.pagination.total_pages', 0);
    },
  },
  methods: {
    onItemClick(params) {
      const data = {
        name: get(this.meta, 'navigation.itemClickNavigation'),
        params,
      };
      console.log('handleItemClick', params, data);
      this.$router.push(data);
    },
    fetch() {
      this.$store.dispatch('GetProgramsList', { type: this.type, params: this.params });
    },
    clean() {
      this.$store.dispatch('ClearProgramsList', { type: this.type });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/search-east/page-search-programs.vue